(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('ContactInfo', ['UserContactInfoTypeEnum', ContactInfoFn]);

    /* user contact info object */
    function ContactInfoFn(UserContactInfoTypeEnum) {
        var ContactInfo = function () {

            // define default values
            this.caption = null;
            this.prefix = '';
            this.value = ''; 
            this.fK_UserContactInfoType = null;
            this.userContactInfoType = null;
            this.showInContactDetails = true;
            this.sortOrder = 0; // default
            this.showInCallForwarding = false; // default
            this.fK_WebConfiguration = null;
            this.isPhone = false;
            this.isMobile = false;
            this.isEmail = false;

            // vmid for display
            this.vmId = null;

            // func
            this.init = init;
            this.extend = extend;
            this.prepareForSave = prepareForSave;

            // init
            function init(type) {
                var self = this;
                
                // set type
                self.fK_UserContactInfoType = type.id;
                self.userContactInfoType = type;
                
                if (type.id === UserContactInfoTypeEnum.Phone.value) {
                    self.isPhone = true;
                } else if (type.id === UserContactInfoTypeEnum.Mobile.value) {
                    self.isMobile = true;
                } else if (type.id === UserContactInfoTypeEnum.Email.value) {
                    self.isEmail = true;
                }

                // vmid for display
                self.vmId = Math.random();
            }

            // extend
            function extend (object) {
                var self = this;
                angular.extend(self, object);
                // vmid for display
                self.vmId = Math.random();
            }

            // prepare for backend
            function prepareForSave() {
                var self = this;

                self.fK_UserContactInfoType = self.userContactInfoType ? self.userContactInfoType.id : 0;

                delete self.userContactInfoType;
                delete self.vmId;
            }



        };

        return ContactInfo;
    }
})();